/* eslint-disable */
// @ts-nocheck
/* ============================================================================
 * MTE — Hero asset map v1.1 (Track B overnight, 2026-09-13)
 * ----------------------------------------------------------------------------
 * Extension sémantique du map existant. Chaque HeroId expose plusieurs poses
 * selon le contexte d'usage (idle / success_micro / success_major / thinking /
 * encourage / flight_up). Les écrans importent via getHeroPoseAsset(heroId, pose).
 *
 * Source-of-truth : mte-design/_incoming/ana/<personnage>/ (Ana uploads)
 * Path public servi : /heroes/<personnage>/<ficheiro>
 * Atelier ne renomme PAS les fichiers ; il référence les paths ci-dessous.
 *
 * Poses sémantiques (alignées ninja-ingest-mapping.json) :
 *   idle          : pose neutre, default landing
 *   standing      : idle en pied (success_micro quiet)
 *   curious       : discovery, hover
 *   neutral       : doux-erreur, encouragement
 *   sitting       : calme / sitting
 *   thinking      : processing / loading
 *   success_micro : micro-celebration (correct answer)
 *   success_major : full celebration (level-up)
 *   flight_up     : mission launch / en vol vers aventure
 *   celebrate     : victory (≠ flight_up — pose statique)
 * ========================================================================== */

import type { HeroId } from './placeholders';

export type HeroPose =
  | 'idle'
  | 'standing'
  | 'curious'
  | 'neutral'
  | 'sitting'
  | 'thinking'
  | 'success_micro'
  | 'success_major'
  | 'flight_up'
  | 'celebrate';

export interface HeroPoseAsset {
  heroId: HeroId;
  pose: HeroPose;
  src: string;
  displayName: string;
  isPlaceholder: boolean;
}

/* === Dragon : 14 PNGs, nomenclatura semântica (Gate 6) ============== */

const DRAGON_POSES = [
  { pose: 'idle',          src: '/heroes/dragon/dragon-idle-front.png',                  displayName: 'dragon-idle-front' },
  { pose: 'standing',      src: '/heroes/dragon/dragon-idle-front-standing.png',        displayName: 'dragon-idle-front-standing' },
  { pose: 'curious',       src: '/heroes/dragon/dragon-idle-front-curious.png',         displayName: 'dragon-idle-front-curious' },
  { pose: 'neutral',       src: '/heroes/dragon/dragon-idle-front-neutral.png',         displayName: 'dragon-idle-front-neutral' },
  { pose: 'sitting',       src: '/heroes/dragon/dragon-idle-front-sitting.png',         displayName: 'dragon-idle-front-sitting' },
  { pose: 'thinking',      src: '/heroes/dragon/dragon-thinking-front.png',              displayName: 'dragon-thinking-front' },
  { pose: 'success_micro', src: '/heroes/dragon/dragon-success-micro-laugh.png',         displayName: 'dragon-success-micro-laugh' },
  { pose: 'success_major', src: '/heroes/dragon/dragon-success-major-celebrate.png',     displayName: 'dragon-success-major-celebrate' },
  { pose: 'flight_up',     src: '/heroes/dragon/dragon-success-major-flight-up.png',     displayName: 'dragon-success-major-flight-up' },
  { pose: 'celebrate',     src: '/heroes/dragon/dragon-success-major-celebrate.png',     displayName: 'dragon-success-major-celebrate' },
] as const;

/* === Ninja : 45 PNGs (Ana filenames, sem rename) ====================== */

const NINJA_IDLE = 'ChatGPT Image 11_09_2026, 18_04_38 (1).png';
const NINJA_SUCCESS_MICRO = 'ChatGPT Image 11_09_2026, 18_05_06 (2).png';
const NINJA_THINKING = 'ChatGPT Image 11_09_2026, 18_05_07 (3).png';
const NINJA_CELEBRATE = 'ChatGPT Image 11_09_2026, 18_05_07 (4).png';
const NINJA_FLIGHT_UP = 'ChatGPT Image 11_09_2026, 18_05_08 (5).png';
const NINJA_STANDING = 'ChatGPT Image 11_09_2026, 18_05_08 (6).png';
const NINJA_CURIOUS = 'ChatGPT Image 11_09_2026, 18_05_08 (10).png';
const NINJA_NEUTRAL = 'ChatGPT Image 11_09_2026, 18_05_05 (1).png';
const NINJA_SITTING = 'ChatGPT Image 11_09_2026, 18_05_06 (2).png';

const NINJA_POSES = [
  { pose: 'idle',          src: `/heroes/ninja/${NINJA_IDLE}`,          displayName: 'ninja-idle-front-01' },
  { pose: 'standing',      src: `/heroes/ninja/${NINJA_STANDING}`,      displayName: 'ninja-idle-front-standing' },
  { pose: 'curious',       src: `/heroes/ninja/${NINJA_CURIOUS}`,       displayName: 'ninja-idle-front-curious' },
  { pose: 'neutral',       src: `/heroes/ninja/${NINJA_NEUTRAL}`,       displayName: 'ninja-idle-front-neutral' },
  { pose: 'sitting',       src: `/heroes/ninja/${NINJA_SITTING}`,       displayName: 'ninja-idle-front-sitting' },
  { pose: 'thinking',      src: `/heroes/ninja/${NINJA_THINKING}`,      displayName: 'ninja-thinking-front' },
  { pose: 'success_micro', src: `/heroes/ninja/${NINJA_SUCCESS_MICRO}`, displayName: 'ninja-success-micro' },
  { pose: 'success_major', src: `/heroes/ninja/${NINJA_CELEBRATE}`,     displayName: 'ninja-success-major-celebrate' },
  { pose: 'flight_up',     src: `/heroes/ninja/${NINJA_FLIGHT_UP}`,     displayName: 'ninja-action-jump' },
  { pose: 'celebrate',     src: `/heroes/ninja/${NINJA_CELEBRATE}`,     displayName: 'ninja-success-major-celebrate' },
] as const;

/* === Lobo : 33 PNGs ================================================== */

const LOBO_IDLE = 'ChatGPT Image 11_09_2026, 18_03_16 (1).png';
const LOBO_STANDING = 'ChatGPT Image 11_09_2026, 18_03_16 (2).png';
const LOBO_CURIOUS = 'ChatGPT Image 11_09_2026, 18_03_16 (3).png';
const LOBO_NEUTRAL = 'ChatGPT Image 11_09_2026, 18_03_16 (4).png';
const LOBO_SITTING = 'ChatGPT Image 11_09_2026, 18_03_16 (5).png';
const LOBO_THINKING = 'ChatGPT Image 11_09_2026, 18_03_16 (6).png';
const LOBO_SUCCESS_MICRO = 'ChatGPT Image 11_09_2026, 18_03_16 (7).png';
const LOBO_CELEBRATE = 'ChatGPT Image 11_09_2026, 18_03_16 (8).png';
const LOBO_FLIGHT_UP = 'ChatGPT Image 11_09_2026, 18_03_24 (1).png';

const LOBO_POSES = [
  { pose: 'idle',          src: `/heroes/lobo/${LOBO_IDLE}`,          displayName: 'lobo-idle-front-01' },
  { pose: 'standing',      src: `/heroes/lobo/${LOBO_STANDING}`,      displayName: 'lobo-idle-front-standing' },
  { pose: 'curious',       src: `/heroes/lobo/${LOBO_CURIOUS}`,       displayName: 'lobo-idle-front-curious' },
  { pose: 'neutral',       src: `/heroes/lobo/${LOBO_NEUTRAL}`,       displayName: 'lobo-idle-front-neutral' },
  { pose: 'sitting',       src: `/heroes/lobo/${LOBO_SITTING}`,       displayName: 'lobo-idle-front-sitting' },
  { pose: 'thinking',      src: `/heroes/lobo/${LOBO_THINKING}`,      displayName: 'lobo-thinking-front' },
  { pose: 'success_micro', src: `/heroes/lobo/${LOBO_SUCCESS_MICRO}`, displayName: 'lobo-success-micro' },
  { pose: 'success_major', src: `/heroes/lobo/${LOBO_CELEBRATE}`,     displayName: 'lobo-success-major-celebrate' },
  { pose: 'flight_up',     src: `/heroes/lobo/${LOBO_FLIGHT_UP}`,     displayName: 'lobo-action-flight' },
  { pose: 'celebrate',     src: `/heroes/lobo/${LOBO_CELEBRATE}`,     displayName: 'lobo-success-major-celebrate' },
] as const;

/* === Princesa : 38 PNGs ============================================== */

const PRINCESA_IDLE = 'ChatGPT Image 10_09_2026, 16_12_57 (1).png';
const PRINCESA_STANDING = 'ChatGPT Image 10_09_2026, 16_12_57 (2).png';
const PRINCESA_CURIOUS = 'ChatGPT Image 10_09_2026, 16_12_57 (3).png';
const PRINCESA_NEUTRAL = 'ChatGPT Image 10_09_2026, 16_12_58 (4).png';
const PRINCESA_SITTING = 'ChatGPT Image 10_09_2026, 16_12_58 (5).png';
const PRINCESA_THINKING = 'ChatGPT Image 10_09_2026, 16_23_45 (1).png';
const PRINCESA_SUCCESS_MICRO = 'ChatGPT Image 10_09_2026, 16_23_46 (2).png';
const PRINCESA_CELEBRATE = 'ChatGPT Image 10_09_2026, 16_23_46 (3).png';
const PRINCESA_FLIGHT_UP = 'ChatGPT Image 10_09_2026, 16_32_00 (1).png';

const PRINCESA_POSES = [
  { pose: 'idle',          src: `/heroes/princesse/${PRINCESA_IDLE}`,          displayName: 'princesa-idle-front-01' },
  { pose: 'standing',      src: `/heroes/princesse/${PRINCESA_STANDING}`,      displayName: 'princesa-idle-front-standing' },
  { pose: 'curious',       src: `/heroes/princesse/${PRINCESA_CURIOUS}`,       displayName: 'princesa-idle-front-curious' },
  { pose: 'neutral',       src: `/heroes/princesse/${PRINCESA_NEUTRAL}`,      displayName: 'princesa-idle-front-neutral' },
  { pose: 'sitting',       src: `/heroes/princesse/${PRINCESA_SITTING}`,      displayName: 'princesa-idle-front-sitting' },
  { pose: 'thinking',      src: `/heroes/princesse/${PRINCESA_THINKING}`,     displayName: 'princesa-thinking-front' },
  { pose: 'success_micro', src: `/heroes/princesse/${PRINCESA_SUCCESS_MICRO}`, displayName: 'princesa-success-micro' },
  { pose: 'success_major', src: `/heroes/princesse/${PRINCESA_CELEBRATE}`,     displayName: 'princesa-success-major-celebrate' },
  { pose: 'flight_up',     src: `/heroes/princesse/${PRINCESA_FLIGHT_UP}`,     displayName: 'princesa-action-magic' },
  { pose: 'celebrate',     src: `/heroes/princesse/${PRINCESA_CELEBRATE}`,     displayName: 'princesa-success-major-celebrate' },
] as const;

/* === Sage (mentor fixe) : 12 PNGs (6 staff props + 6 character) ====== */

const SAGE_IDLE = 'ChatGPT Image 13_09_2026, 00_56_24 (2).png';
const SAGE_STANDING = 'ChatGPT Image 13_09_2026, 00_56_24 (3).png';
const SAGE_THINKING = 'ChatGPT Image 13_09_2026, 01_23_16 (1).png';
const SAGE_SUCCESS_MICRO = 'ChatGPT Image 13_09_2026, 01_23_17 (2).png';
const SAGE_CELEBRATE = 'ChatGPT Image 13_09_2026, 01_23_17 (3).png';
const SAGE_FLIGHT_UP = 'ChatGPT Image 13_09_2026, 01_23_18 (4).png';
const SAGE_NEUTRAL = 'ChatGPT Image 13_09_2026, 01_23_18 (5).png';
const SAGE_SITTING = 'ChatGPT Image 13_09_2026, 01_23_18 (6).png';
const SAGE_CURIOUS = 'ChatGPT Image 13_09_2026, 01_23_18 (4).png';

const SAGE_POSES = [
  { pose: 'idle',          src: `/heroes/sage/${SAGE_IDLE}`,          displayName: 'sage-idle-front-01' },
  { pose: 'standing',      src: `/heroes/sage/${SAGE_STANDING}`,      displayName: 'sage-idle-front-standing' },
  { pose: 'curious',       src: `/heroes/sage/${SAGE_CURIOUS}`,       displayName: 'sage-idle-front-curious' },
  { pose: 'neutral',       src: `/heroes/sage/${SAGE_NEUTRAL}`,       displayName: 'sage-idle-front-neutral' },
  { pose: 'sitting',       src: `/heroes/sage/${SAGE_SITTING}`,       displayName: 'sage-idle-front-sitting' },
  { pose: 'thinking',      src: `/heroes/sage/${SAGE_THINKING}`,      displayName: 'sage-thinking-front' },
  { pose: 'success_micro', src: `/heroes/sage/${SAGE_SUCCESS_MICRO}`, displayName: 'sage-encouraging-a' },
  { pose: 'success_major', src: `/heroes/sage/${SAGE_CELEBRATE}`,     displayName: 'sage-success-major-celebrate' },
  { pose: 'flight_up',     src: `/heroes/sage/${SAGE_FLIGHT_UP}`,     displayName: 'sage-action-flight' },
  { pose: 'celebrate',     src: `/heroes/sage/${SAGE_CELEBRATE}`,     displayName: 'sage-success-major-celebrate' },
] as const;

/* === Fada / Chat : assets canon disponibles =========================== */

const FADA_POSES = [
  { pose: 'idle',          src: '/heroes/fada/ChatGPT Image 14_09_2026, 00_23_46 (1).png', displayName: 'fada-idle-front-01' },
  { pose: 'standing',      src: '/heroes/fada/ChatGPT Image 14_09_2026, 00_23_46 (2).png', displayName: 'fada-idle-front-standing' },
  { pose: 'curious',       src: '/heroes/fada/ChatGPT Image 14_09_2026, 00_23_46 (3).png', displayName: 'fada-idle-front-curious' },
  { pose: 'thinking',      src: '/heroes/fada/ChatGPT Image 14_09_2026, 00_23_47 (4).png', displayName: 'fada-thinking-front' },
  { pose: 'success_micro', src: '/heroes/fada/ChatGPT Image 14_09_2026, 00_23_47 (5).png', displayName: 'fada-success-micro' },
  { pose: 'celebrate',     src: '/heroes/fada/ChatGPT Image 14_09_2026, 00_23_55 (1).png', displayName: 'fada-success-major-celebrate' },
] as const;

const GATO_POSES = [
  { pose: 'idle',          src: '/heroes/gato/preto/gato-preto-dark-01.png', displayName: 'chat-idle-front-01' },
  { pose: 'standing',      src: '/heroes/gato/preto/gato-preto-dark-02.png', displayName: 'chat-idle-front-standing' },
  { pose: 'curious',       src: '/heroes/gato/preto/gato-preto-dark-03.png', displayName: 'chat-idle-front-curious' },
  { pose: 'thinking',      src: '/heroes/gato/preto/gato-preto-sknt-01.png', displayName: 'chat-thinking-front' },
  { pose: 'success_micro', src: '/heroes/gato/preto/gato-preto-gldn-01.png', displayName: 'chat-success-micro' },
  { pose: 'celebrate',     src: '/heroes/gato/preto/gato-preto-gldn-02.png', displayName: 'chat-success-major-celebrate' },
] as const;

/* === Master map ====================================================== */

export const HERO_POSE_MAP = new Map<HeroId, ReadonlyArray<HeroPoseAsset>>([
  ['dragao',   DRAGON_POSES.map((p) => ({ ...p, heroId: 'dragao' as HeroId,   isPlaceholder: false }))],
  ['ninja',    NINJA_POSES.map((p) => ({ ...p, heroId: 'ninja' as HeroId,    isPlaceholder: false }))],
  ['lobo',     LOBO_POSES.map((p) => ({ ...p, heroId: 'lobo' as HeroId,     isPlaceholder: false }))],
  ['princesa', PRINCESA_POSES.map((p) => ({ ...p, heroId: 'princesa' as HeroId, isPlaceholder: false }))],
  ['fada',     FADA_POSES.map((p) => ({ ...p, heroId: 'fada' as HeroId, isPlaceholder: false }))],
  ['gato',     GATO_POSES.map((p) => ({ ...p, heroId: 'gato' as HeroId, isPlaceholder: false }))],
  ['sage',     SAGE_POSES.map((p) => ({ ...p, heroId: 'sage' as HeroId,     isPlaceholder: false }))],
]);

/* === Public lookup =================================================== */

export function getHeroPoseAsset(heroId: HeroId, pose: HeroPose): HeroPoseAsset {
  const list = HERO_POSE_MAP.get(heroId);
  if (!list || list.length === 0) {
    return {
      heroId,
      pose: 'idle',
      src: `/heroes/${heroId}/placeholder.svg`,
      displayName: `${heroId}-fallback`,
      isPlaceholder: true,
    };
  }
  return (
    list.find((a) => a.pose === pose) ??
    list.find((a) => a.pose === 'idle') ??
    list[0]
  );
}

/* === Backwards-compat exports (Track A staging já usa estes) ======== */

export interface HeroAsset {
  heroId: HeroId;
  src: string;
  isPlaceholder: boolean;
  displayName: string;
}

export const HERO_MAIN_ASSET: ReadonlyArray<HeroAsset> = (
  ['dragao', 'ninja', 'lobo', 'princesa', 'fada', 'gato', 'sage'] as const
).map((heroId) => {
  const a = getHeroPoseAsset(heroId, 'idle');
  return { heroId: a.heroId, src: a.src, isPlaceholder: a.isPlaceholder, displayName: a.displayName };
});

export const HERO_ASSET_MAP: ReadonlyMap<HeroId, HeroAsset> = new Map(
  HERO_MAIN_ASSET.map((a) => [a.heroId, a])
);

export function getHeroAsset(id: HeroId): HeroAsset {
  const a = getHeroPoseAsset(id, 'idle');
  return { heroId: a.heroId, src: a.src, isPlaceholder: a.isPlaceholder, displayName: a.displayName };
}
